/**
 * components/Controls.jsx
 * Receives bulk handlers from FormsListApp, passes to BulkActions.
 */

import { useCrudListState } from "../context/CrudContext";
import ControlSearch from "./controls/ControlSearch";
import StatusFilter from "./controls/StatusFilter";
import BulkActions from "./controls/BulkActions";

export default function Controls({
    onBulkTrash,
    onBulkRestore,
    onBulkPermanentDelete,
    onBulkStatus,
}) {
    const { selected } = useCrudListState();
    const hasSelection = selected.length > 0;

    return (
        <div className="px-4 sm:px-6 py-4 bg-gray-50 border-b border-gray-200">
            <div className="flex flex-col sm:flex-row sm:items-center gap-3">
                <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto">
                    <ControlSearch />
                    <StatusFilter />
                    {hasSelection && (
                        <BulkActions
                            onBulkTrash={onBulkTrash}
                            onBulkRestore={onBulkRestore}
                            onBulkPermanentDelete={onBulkPermanentDelete}
                            onBulkStatus={onBulkStatus}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}
